export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}

const AVATAR_VARS = [
  'var(--avatar-1)',
  'var(--avatar-2)',
  'var(--avatar-3)',
  'var(--avatar-4)',
  'var(--avatar-5)',
  'var(--avatar-6)',
  'var(--avatar-7)',
];

/** Cor determinística baseada no slug — mesma cor para o mesmo workspace. */
export function colorFromSlug(slug: string): string {
  let h = 0;
  for (let i = 0; i < slug.length; i++) {
    h = (h * 31 + slug.charCodeAt(i)) >>> 0;
  }
  return AVATAR_VARS[h % AVATAR_VARS.length]!;
}

export type WsStatusLabel = 'ativo' | 'suspenso' | 'arquivado';
export type StatusTone = 'pass' | 'warn' | 'block' | 'info';

export function statusLabel(status: 'ACTIVE' | 'SUSPENDED' | 'ARCHIVED'): WsStatusLabel {
  switch (status) {
    case 'ACTIVE': return 'ativo';
    case 'SUSPENDED': return 'suspenso';
    case 'ARCHIVED': return 'arquivado';
  }
}

export function statusTone(status: 'ACTIVE' | 'SUSPENDED' | 'ARCHIVED'): StatusTone {
  switch (status) {
    case 'ACTIVE': return 'pass';
    case 'SUSPENDED': return 'block';
    case 'ARCHIVED': return 'info';
  }
}
